import {
  GSTR2_REPORT_REQUEST,
  GSTR2_REPORT_SUCCESS,
  GSTR2_REPORT_FAILURE,
} from "../types/gstr2-report-types";

const initialState = {
  gstr2Report: {},
  loading: false,
  error: null,
};

const gstr2ReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GSTR2_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GSTR2_REPORT_SUCCESS: {
      return {
        ...state,
        gstr2Report: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case GSTR2_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default gstr2ReportReducer;
